<template>
    <div class="relative" ref="containerRef">
        <ul
            v-if="show"
            ref="menuRef"
            class="bg-white dark:bg-slate-800 rounded-lg shadow-lg min-w-64 absolute z-20"
            :style="menuStyles"
            v-click-outside="() => $emit('close')"
        >
            <li>
                <button
                    type="button"
                    class="w-full p-2 text-sm text-gray-900 dark:text-gray-100 rounded text-left hover:bg-gray-100 dark:hover:bg-slate-700 focus:bg-gray-100 dark:focus:bg-slate-700 focus:outline-none transition-colors"
                    @click="selectTierType('points')"
                >
                    Points
                </button>
            </li>
            <li>
                <button
                    type="button"
                    class="w-full p-2 text-sm text-gray-900 dark:text-gray-100 rounded text-left hover:bg-gray-100 dark:hover:bg-slate-700 focus:bg-gray-100 dark:focus:bg-slate-700 focus:outline-none transition-colors"
                    @click="selectTierType('cashback')"
                >
                    Cash back
                </button>
            </li>
            <li>
                <button
                    type="button"
                    class="w-full p-2 text-sm text-gray-900 dark:text-gray-100 rounded text-left hover:bg-gray-100 dark:hover:bg-slate-700 focus:bg-gray-100 dark:focus:bg-slate-700 focus:outline-none transition-colors"
                    @click="selectTierType('free_nights')"
                >
                    Free night certificates
                </button>
            </li>
        </ul>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { useFloating, offset, flip, shift } from '@floating-ui/vue';

const emit = defineEmits(['select-tier-type', 'close']);
const props = defineProps({
    show: {
        type: Boolean,
        default: false,
    },
});

const menuRef = ref(null);
const containerRef = ref(null);

const { floatingStyles: menuStyles } = useFloating(containerRef, menuRef, {
    placement: 'right-end',
    strategy: 'absolute',
    middleware: [offset(5), flip(), shift()],
});

const selectTierType = (type) => {
    emit('select-tier-type', type);
};
</script>
